var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 36C72 55.8823 55.8823 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C55.8823 0 72 16.1177 72 36Z",
    fill: "#008DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8192 17H26.8028L25.4746 24.4798L39.9313 24.4971C47.0526 24.4971 49.1521 27.1056 49.0921 31.4242C49.0578 33.6353 48.1066 37.3839 47.6953 38.6017C46.5984 41.8407 44.3446 45.5288 35.8951 45.5202L21.8411 45.5115L20.5128 53H36.4949C42.1337 53 44.5246 52.3349 47.0697 51.1603C52.6999 48.5259 56.0505 42.929 57.3959 35.6219C59.3926 24.739 56.9075 17 42.8192 17Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8872 31.2428C15.6882 31.2428 15.0883 33.9981 14.6941 35.6651C14.1714 37.8416 14 38.7313 14 38.7313H30.402C34.601 38.7313 35.2009 35.976 35.5951 34.309C36.1178 32.1324 36.2892 31.2428 36.2892 31.2428H19.8872Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.6697b4e61e112d3c289bd055e3d8840a.svg";
export { ForwardRef as ReactComponent };